import React from "react"

export default React.createContext({ user: null, userSelectedAddress: null, setUser: () => null })
